exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-copy-show-disc {\n  -webkit-text-security: disc;\n}\n", ""]);

